import { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Divider, } from "antd";

import { get } from "library/endpoints";

// Inner
// import ToCompleteTable from "./components/ToCompleteTable";
import FinishedTable from "./components/FinishedTable";
import Title from "components/Title";

/**
 * History
 * @param {*} props 
 * @returns 
 */
const History = (props) => {
  const [data, setData] = useState([]);
  const [bills, setBills] = useState([]);
  
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      const response = await get(`/frontend/basket/history`);
      const responseBills = await get(`/frontend/basket/bills`);
      setBills(responseBills.data)
      setData(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div>
      <Title size={18}>Vos commandes</Title>
      <Divider />

      <FinishedTable entries={data} bills={bills} />

    </div>
  )
}

export default withTranslation()(History);